import {vacancyService} from '@/services/employers/vacancyService'
import { getEmployerVacanciesAsync, 
        searchEmployerVacanciesAsync,
        changeVisibilityAsync,
        deleteVacancyAsync,
        deleteAllVacanciesAsync} from '@/services/employers/vacancyService';
export const employerVacancies = {
    namespaced: true,
    state:{
        vacancies: null,
        vacanciesMetaData: null
    },
    getters:{
        getVacancies(state){
            return state.vacancies
        },
        getVacanciesMetaData(state){
            return state.vacanciesMetaData
        }
    },
    mutations:{
        setVacancies(state,vacancies){
            state.vacancies = vacancies;
        },
        setVacanciesMetaData(state,vacanciesMetaData){
            state.vacanciesMetaData = vacanciesMetaData;
        },
        updateVacancy(state,vacancy){
            const _vacancy = state.vacancies.find(v => v.jobId === vacancy.jobId);
            if(_vacancy){
                _vacancy.jobTitle = vacancy.jobTitle;
                _vacancy.location = vacancy.location;
                _vacancy.closingDate = vacancy.closingDate;
                _vacancy.description = vacancy.description;
                _vacancy.totalApplicants = vacancy.totalApplicants;
                _vacancy.totalShortList = vacancy.totalShortList;
                _vacancy.isVisible = vacancy.isVisible;
            }
        },
        removeVacancy(state,jobId){
           state.vacancies = state.vacancies.filter(v => v.jobId !== jobId); 
        },
        removeAllVacancies(state){
            state.vacancies = [];
            state.vacanciesMetaData = null;
        }
    },
    actions:{
       async getVacanciesAsync({commit}, page){
            var response = await getEmployerVacanciesAsync(page);
            if(!response.success){
                    const err = new Error(res.message, {reason: response.caption});
                    err.caption = res.caption;
                    throw err;
                }else{
                    commit('setVacancies', response.vacancies);
                    commit('setVacanciesMetaData', response.meta);
                }
        },
        async changeVisibilityAsync({commit}, jobId){
            var response = await changeVisibilityAsync(jobId);
            if(!response.success){
                    const err = new Error(res.message, {reason: response.caption});
                    err.caption = res.caption;
                    throw err;
                }else{
                    commit('updateVacancy', response.job);
                }
        },
         async searchVacanciesAsync({commit}, content){
            var response = await searchEmployerVacanciesAsync(content.data,content.page);
            if(!response.success){
                    if(!response.errors){
                    const err = new Error(response.message, {reason: response.caption});
                    err.caption = response.caption;
                    throw err;
                    }else{
                        var errorMessages = "";
                        console.log(response.errors);
                        for(var error of response.errors){
                            errorMessages += `${error}<br/>`;
                        }
                        throw new Error(errorMessages, {reason: response.caption})
                    }
                }else{
                    commit('setVacancies', response.vacancies);
                    commit('setVacanciesMetaData', response.meta);
                }
        },
         async deleteVacancyAsync({commit}, jobId){
            var response = await deleteVacancyAsync(jobId)
            if(!response.success){     
                    const err = new Error(response.message, {reason: response.caption});
                    err.caption = response.caption;
                    throw err;
                }else{
                    commit('removeVacancy', jobId);
                }
        },
         editVacancy({commit}, vacancy){  
                    commit('updateVacancy', vacancy);
        },
         async deleteAllVacanciesAsync({commit}){
            var response = await deleteAllVacanciesAsync();
            if(!response.success){     
                    const err = new Error(response.message, {reason: response.caption});
                    err.caption = response.caption;
                    throw err;
                }else{
                    commit('removeAllVacancies');
                }
        },

    }

}